import React from 'react';
import { Field } from '../Field';
import { Field as FieldType } from '../../types';

export const Section: React.FC<any> = ({
  section,
  item,
  selectedPath,
  onFieldSelect,
  getSetterConfig,
  getOptions,
  visibleFields,
  formValues,
}) => {
  return (
    <div className="section-content">
      {item.fields.map((field: FieldType) => {
        const fieldName = typeof field === 'string' ? field : field.name;
        const config = getSetterConfig(fieldName);
        const path = `setters.${section.name}.${item.name}.${fieldName}`;
        
        return (
          <Field
            key={fieldName}
            field={field}
            sectionName={section.name}
            itemName={item.name}
            isSelected={selectedPath === path}
            config={config}
            options={config ? getOptions(config, formValues) : undefined}
            onSelect={onFieldSelect}
            getSetterConfig={getSetterConfig}  // 传递这些函数
            getOptions={getOptions}
            formValues={formValues}
            visibleFields={visibleFields}
          />
        );
      })}
    </div>
  );
};